<template>
  <hm-content title>
    <div class="table-panel flex flex-end flex-wrap">
      <el-date-picker
        size="small"
        :clearable="false"
        class="mr10"
        v-model="searchConditions.date"
        ref="datepicker"
        value-format="yyyy-MM-dd HH:mm:ss"
        :default-time="['00:00:00', '23:59:59']"
        type="datetimerange"
        range-separator="至"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
      ></el-date-picker>
      <el-input
        clearable
        v-model.trim="searchConditions.orderId"
        placeholder="输入订单号"
        size="small"
        class="ipt mr10"
      ></el-input>
      <el-input
        clearable
        type="number"
        v-model.trim="searchConditions.totPriceMin"
        placeholder="输入最小订单金额"
        size="small"
        class="ipt mr10"
      ></el-input>
      <el-input
        type="number"
        clearable
        v-model.trim="searchConditions.mobile"
        placeholder="输入会员手机号"
        size="small"
        class="ipt mr10"
      ></el-input>
      <el-button type="primary" size="small" @click="search">查询</el-button>
    </div>
    <div class="table">
      <el-table
        stripe
        border
        :data="list"
        style="width: 100%"
        id="table"
        size="small"
      >
        <el-table-column
          type="index"
          label="序号"
          header-align="center"
          align="center"
          :index="index => index + (currentPage - 1) * pageSize + 1"
        ></el-table-column>
        <!-- <el-table-column header-align="center" prop="orderOfflineId" align="center" label="线下订单号">
        </el-table-column>-->
        <el-table-column
          header-align="center"
          prop="orderId"
          align="center"
          label="订单号"
        ></el-table-column>
        <el-table-column
          header-align="center"
          prop="addTime"
          align="center"
          label="订单销售时间"
        ></el-table-column>
        <el-table-column
          header-align="center"
          prop="createTime"
          align="center"
          label="订单同步时间"
        ></el-table-column>
        <el-table-column
          header-align="center"
          prop="memberCardId"
          align="center"
          label="会员卡ID"
        ></el-table-column>
        <el-table-column header-align="center" align="center" label="订单金额">
          <template slot-scope="scope">
            <span class="primary">￥{{ scope.row.totPrice }}</span>
          </template>
        </el-table-column>
        ></el-table-column>
        <el-table-column header-align="center" align="center" label="实付金额">
          <template slot-scope="scope">
            <span class="primary">￥{{ scope.row.actuallyPrice }}</span>
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          prop="memberName"
          align="center"
          label="会员姓名"
        ></el-table-column>
        <el-table-column
          header-align="center"
          prop="memberMobile"
          align="center"
          label="会员电话"
        ></el-table-column>
        <el-table-column header-align="center" align="center" label="操作">
          <template slot-scope="scope">
            <div class="flex flex-center">
              <el-tooltip class="item" content="订单详情" placement="top">
                <div class="pointer mr20" @click="viewOrder(scope.row)">
                  <span class="hmicon icon-chakan blue"></span>
                </div>
              </el-tooltip>
              <el-tooltip class="item" content="发券" placement="top">
                <div class="pointer" @click="sendCoupon(scope.row)">
                  <span class="hmicon icon-mianduimianfaquanhui purple"></span>
                </div>
              </el-tooltip>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <el-dialog
      title="订单详情"
      :close-on-click-modal="false"
      :visible.sync="dialogVisible"
      width="600px"
    >
      <el-scrollbar :vertical="false" wrap-style="height: 300px;">
        <div class="mb20" v-if="orderDetail && orderDetail.length">
          <div>订单号：{{ orderDetail[0].order_id }}</div>
          <div class="mt10">销售日期：{{ orderDetail[0].sale_date }}</div>
          <div class="mt10">会员：{{ orderDetail[0].full_name }}</div>
          <div class="mt10">实付金额：<span class="primary">￥{{ orderDetail[0].actually_price }}</span></div>
        </div>
        <div class="dialog-body">
          <div class="mb20">
            <div class="table-panel title">商品信息</div>
            <div class="table">
              <el-table
                stripe
                border
                :data="orderDetail"
                style="width: 100%"
                id="table"
                size="small"
              >
                <el-table-column
                  header-align="center"
                  prop="goods_name"
                  align="center"
                  label="商品名称"
                ></el-table-column>
                <el-table-column
                  header-align="center"
                  prop="spec_barcode"
                  align="center"
                  label="条码"
                ></el-table-column>
                <el-table-column
                  header-align="center"
                  prop="goods_sn"
                  align="center"
                  label="货号"
                ></el-table-column>
                <!-- <el-table-column
                  header-align="center"
                  align="center"
                  label="市场价"
                >
                  <template slot-scope="scope">
                    <span class="primary">￥{{ scope.row.market_price }}</span>
                  </template>
                </el-table-column> -->
                <!-- <el-table-column
                  header-align="center"
                  align="center"
                  label="门店价"
                >
                  <template slot-scope="scope">
                    <span class="primary">￥{{ scope.row.shop_price }}</span>
                  </template>
                </el-table-column> -->
                <el-table-column
                  header-align="center"
                  prop="goods_number"
                  align="center"
                  label="商品数量"
                ></el-table-column>
                <el-table-column
                  header-align="center"
                  prop="total_shop_price"
                  align="center"
                  label="小计金额"
                ></el-table-column>
              </el-table>
            </div>
          </div>
          <div v-if="couponInfo.length">
            <div class="table-panel title">购买后已发放优惠券</div>
            <div class="table">
              <el-table
                stripe
                border
                :data="couponInfo"
                style="width: 100%"
                id="table"
                size="small"
              >
                <el-table-column
                  header-align="center"
                  prop="name"
                  align="center"
                  label="优惠券名"
                />
                <el-table-column
                  header-align="center"
                  prop="sendName"
                  align="center"
                  label="发放规则名"
                />
                <el-table-column
                  header-align="center"
                  prop="toOrder"
                  align="center"
                  label="已使用订单号"
                />
                <el-table-column
                  header-align="center"
                  prop="couponCode"
                  align="center"
                  label="优惠券码"
                />
                <el-table-column
                  header-align="center"
                  align="center"
                  label="优惠券状态"
                >
                  <template slot-scope="scope">
                    <span class="primary" v-if="scope.row.couponStatus === 2"
                      >已使用</span
                    >
                    <span class="primary" v-if="scope.row.couponStatus === 4"
                      >未使用</span
                    >
                    <span class="primary" v-if="scope.row.couponStatus === 5"
                      >冻结</span
                    >
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </div>
        </div>
      </el-scrollbar>
      <span slot="footer" class="dialog-footer flex flex-center">
        <el-button @click="sendCoupon(currentRow)" size="small" type="primary"
          >发券</el-button
        >
        <el-button @click="dialogVisible = false" size="small">关闭</el-button>
      </span>
    </el-dialog>
    <div class="hm-pagination">
      <el-pagination
        background
        :total="total"
        @current-change="paging"
        @size-change="handleSizeChange"
        :page-size="pageSize"
        layout="total,sizes,  prev, pager, next, jumper"
        :current-page="currentPage"
      ></el-pagination>
    </div>
  </hm-content>
</template>

<script>
import moment from "moment";
export default {
  components: {},
  data() {
    return {
      couponInfo: [],
      orderDetail: [],
      dialogVisible: false,
      currentPage: 1,
      pageSize: 10,
      searchConditions: {
        date: [
          moment().format("YYYY-MM-DD 00:00:00"),
          moment().format("YYYY-MM-DD 23:59:59")
        ]
      },
      checkActivityRecordList: {},
      list: [],
      total: 0,
      currentRow: {}
    };
  },
  computed: {},
  watch: {},
  created() {
    this.queryList();
  },
  mounted() {},
  methods: {
    async viewOrder(row) {
      const { result } = await this.$store.dispatch(
        "queryOfflineOrderDetails",
        {
          orderId: row.orderId,
          orderOfflineId: row.orderOfflineId
        }
      );
      const { couponInfo, orderDetail } = result;
      this.couponInfo = couponInfo;
      this.orderDetail = orderDetail;
      this.currentRow = row;
      this.dialogVisible = true;
    },
    async sendCoupon(row) {
      const startDate = this.searchConditions.date[0];
      const endDate = this.searchConditions.date[1];
      const result = await this.$confirm(
        `确定给${row.memberName}发券?`,
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        }
      );
      if (result === "confirm") {
        const { result } = await this.$store.dispatch("offlineOrderSend", {
          startDate,
          endDate,
          orderId: row.orderId
        });
        const { couponSendName } = result;
        this.$message({
          type: "success",
          message: "发券" + couponSendName + "成功"
        });
        this.dialogVisible = false;
      }
    },
    search() {
      this.currentPage = 1;
      this.queryList();
    },
    paging(page) {
      this.currentPage = page;
      this.queryList();
    },
    handleSizeChange(size) {
      this.currentPage = 1;
      this.pageSize = size;
      this.queryList();
    },
    async queryList() {
      let params = {
        pageSize: this.pageSize,
        pageNo: this.currentPage
      };
      Object.assign(params, this.searchConditions);
      params.startDate = params.date[0];
      params.endDate = params.date[1];
      const { result } = await this.$store.dispatch(
        "queryOfflineOrderList",
        params
      );
      const { records, total } = result;
      this.list = records;
      this.total = total;
    }
  }
};
</script>
<style lang="scss" scoped>
.title {
  &::before {
    display: inline-block;
    margin-right: 10px;
    content: "";
    width: 4px;
    height: 12px;
    background: #e50065;
    border-top-left-radius: 30px;
    border-bottom-right-radius: 30px;
  }
}
</style>
